<template>
  <!-- 공지사항 입력/수정/삭제 -->
  <Transition name="fade">
    <NoticeEditor v-if="isEditOpen" :isEditOpen="isEditOpen" :isModify="isModify" :modifyID="modifyID" :toggleEditor="toggleEditor" :selectedNotice="selectedNotice" :editMode="editMode"></NoticeEditor>
  </Transition>
  
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="row">
              <div class="col-md-4">
                <span class="mb-0" style="font-size: 1rem; line-height: 1.625; font-weight: 600; margin-top: 0; color: #344767">공지사항 관리</span>
              </div>
              <div class="col-md-2">
                
              </div>
              <div class="col-md-2 text-center">
                
              </div>
              <div class="col-md-2">
                <!-- <input type="text" class="form-control" placeholder="검색어 입력" @input="search($event.target.value)"/> -->
              </div>
              <div class="col-md-2 text-center">
                <button class="btn btn-onmaum btn-sm ms-auto w-100" @click="createNotice()">신규</button>
              </div>
              
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0 onmaum-h-80-v onmaum-overflow onmaum-overflow-type02">
              <table class="table table-striped text-center table align-items-center mb-0" id="customerTable">
                <thead>
                  <tr>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">번호</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">제목</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">게시기간</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">게시여부</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">게시형식</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">생성자</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">생성일</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">수정자</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col">수정일</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-if="noticeInfoOrigin.length == 0">
                    <td colspan="9" class="text-center">등록된 공지사항 정보가 없습니다.</td>
                  </tr>
                  <tr class="text-center" v-for="(notice, i) in noticeInfoOrigin" :key="i">
                    <td>
                      <p class="text-sm font-weight-bold mb-0">{{ i + 1 }}</p>
                    </td>
                    <td>
                      <p class="text-sm text-onmaum-hover font-weight-bold mb-0" @click="selectNotice(notice)">{{ notice.title }}</p>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">{{ new Date(notice.start_dt).toLocaleString() }} ~ {{ new Date(notice.end_dt).toLocaleString() }}</p>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">
                        <span class="badge bg-primary" v-if="notice.isPublish">게시</span>
                        <span class="badge bg-danger" v-if="!notice.isPublish">미게시</span>
                      </p>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">
                        <span class="badge bg-info" v-if="notice.kind == '1'">팝업</span>
                        <span class="badge bg-success" v-if="notice.kind == '2'">알림</span>
                      </p>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">{{ notice.insert_name }}</p>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">{{ notice.insert_dt }}</p>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">{{ notice.update_name??'' }}</p>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">{{ notice.update_dt??'' }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>

import NoticeEditor from '../components/NoticeEditor.vue'

export default {
    name: 'noticeManage',
    data(){
      return {
        isEditOpen: false,
        isModify: false,
        modifyID: 0,
        selectedNotice: {},
        editMode: 0,
      }
    },

    components:{
      NoticeEditor
    },

    methods:{
      //신규 공지사항 생성
      createNotice(){
        this.isEditOpen = true;
        this.isModify = false;
        this.modifyID = 0;
        this.selectedNotice = {};
        this.editMode = 2;
      },

      //공지사항 조회
      selectNotice(notice){
        this.isEditOpen = true;
        this.isModify = true;
        this.modifyID = notice._id;
        this.selectedNotice = notice;
        this.editMode = 1;
        
      },

      //공지사항 입력 수정 모달창 토글
      toggleEditor(){
        this.isEditOpen = !this.isEditOpen;
      },
    },

    computed: {
      noticeInfoOrigin(){
        return this.$store.state.common.noticeInfoOrigin;
      }
    },

    mounted(){
      //공지사항 정보 가져오기
      this.$store.dispatch('getNoticeInfo');
    }
}
</script>
  
<style>

</style>